'use strict';

// Import jQuery and Bootstrap (bundled by webpack)
import $ from 'jquery';
import * as bootstrap from 'bootstrap';

// Bootstrap elements functionality
const anchor = () => {
  if (window.location.hash) {
    const anchorID = window.location.hash.substring(1);
    let $elementToOpen = $('[data-anchor-id="' + anchorID + '"]');
    let $elementToScroll = null;

    if ($elementToOpen.length > 0) {
      if ($elementToOpen.hasClass('tc-neos-elements-bootstrap-accordionitem')) {
        openAccordion($elementToOpen);
      } else if ($elementToOpen.parents('.tc-neos-elements-bootstrap-accordionitem').length > 0) {
        $elementToScroll = $elementToOpen;
        $elementToOpen = $elementToOpen.parents('.tc-neos-elements-bootstrap-accordionitem');
        openAccordion($elementToOpen);
        scrollToElement($elementToScroll);
      } else if ($elementToOpen.hasClass('nav-item')) {
        openTab($elementToOpen.children('button.nav-link'));
      } else if ($elementToOpen.parents('.tab-pane').length > 0) {
        const tabId = $elementToOpen.parents('.tab-pane').attr('id');
        $elementToScroll = $elementToOpen;
        $elementToOpen = $('button[data-bs-target="#' + tabId + '"]');
        openTab($elementToOpen);
        scrollToElement($elementToScroll);
      }
    }
  }
}

const openAccordion = ($elementToOpen) => {
  // Use Bootstrap JS from import
  if (bootstrap && bootstrap.Collapse) {
    const collapseElement = $elementToOpen.find('.collapse')[0];
    if (collapseElement) {
      new bootstrap.Collapse(collapseElement, { show: true });
    }
  }
}

const openTab = ($elementToOpen) => {
  // Use Bootstrap JS from import
  if (bootstrap && bootstrap.Tab) {
    const tabElement = $elementToOpen[0];
    if (tabElement) {
      new bootstrap.Tab(tabElement).show();
    }
  }
}

const scrollToElement = ($elementToScroll) => {
  let y = $elementToScroll.offset().top;
  const header = document.getElementById('main-header');

  if (header) {
    const headerStyles = window.getComputedStyle(header);

    if (headerStyles.position === 'fixed') {
      y -= header.offsetHeight;
    }
  }

  $('html, body').animate({
    scrollTop: y
  }, 500);
}

export default {anchor}
